import { WarningType } from 'api';

export const getWarningTypeName = (warningType: WarningType): string => {
  const warningTypeNames: Record<WarningType, string> = {
    [WarningType.Informal]: 'Informal',
    [WarningType.FirstWrittenWarning]: 'First Written Warning',
    [WarningType.FinalWrittenWarning]: 'Final Written Warning',
    [WarningType.GrossMisconduct]: 'Gross Misconduct',
    [WarningType.GrossNegligence]: 'Gross Negligence',
  };
  return warningTypeNames[warningType] ?? '-';
};
